import { combineReducers } from "@reduxjs/toolkit";
import todos from './todoList/todoSlice';
import auth from './auth/auth-slice';
import global from './global/global-slice';
import categories from './categories/categories-slice';
import tags from './tags/tags-slice';
import notification from './notification/notification-slice';
import countries from './countries/countries-slice';

const rootReducer = combineReducers({
    todos,
    auth,
    global,
    categories,
    tags,
    notification,
    countries
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
